import { createServerSidePaginatedFetcher } from '../contexts/Fetcher';
import { apiOrganization } from '../resources/api/apiOrganization';

const { useGetOrganizations } = apiOrganization;

export const OrganizationsFetcher = createServerSidePaginatedFetcher(() => useGetOrganizations().execute);
